// src/util/auth_events.js

const EVENT = "cosmetink:session-expired";

export const emitSessionExpired = (reason = "expired") => {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { reason } }));
};

export const onSessionExpired = (handler) => {
  const fn = (e) => handler?.(e?.detail?.reason || "expired");
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
};
